<template>
  <div class="floating-agent">
    <div class="price">
      <div class="price-total">
        <span :style="getDelStyle">{{ $t('sellingPrice') }}{{ getStatus }}</span>
        <span class="price-num" :class="{ 'line-through': info.status === 'sold' || info.status === 'unavailbale' }">
          <money :value="getPrice(info)" v-bind="getPriceCurrency(info)"></money>
        </span>
      </div>
      <div class="price-calc">
        <span>{{ $t('unitPrice') }}</span>
        <span class="price-calc-num" v-if="info.detail">
          <money :value="getUnitPrice" v-bind="getPriceCurrency(info)"></money>
          <span>/{{ $t('sqm') }}</span>
        </span>
      </div>
    </div>

    <!-- <AgentCard :agent="info.agent" @showDrawer="showDrawer"></AgentCard> -->
  </div>
</template>

<script>
import { Money } from 'v-money'
// import AgentCard from '../AgentCard.vue'

export default {
  props: { info: Object },
  data() {
    return {
      showMorePrice: false,
      currencyConfig: {
        symbol: '$',
        thousandsSeparator: ',',
        fractionCount: 2,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: '',
      },
      currencyConfigInt: {
        symbol: '$',
        thousandsSeparator: ',',
        fractionCount: 0,
        fractionSeparator: '.',
        symbolPosition: 'front',
        symbolSpacing: '',
      },
    }
  },
  components: { Money },
  computed: {
    getUnitPrice() {
      return Math.ceil(this.info.price / this.info.detail.sqft)
    },
    getStatus() {
      if (this.info && this.$i18n.locale === 'en') {
        if (this.info.status === 'pending') {
          return ' (pending)'
        } else if (this.info.status === 'sold') {
          return ' (sold)'
        } else if (this.info.status === 'unavailbale') {
          return ' (sold)'
        }
      }
      return ''
    },
    getDelStyle() {
      if (this.info && this.info.status) {
        if (this.info.status === 'sold' || this.info.status === 'unavailbale') {
          return 'text-decoration:line-through;'
        }
      }
      return ''
    },
  },
  methods: {
    showWechat(agent) {
      this.$msgbox({
        title: '',
        customClass: 'wechat-popup',
        message: `<div style="text-align: center; padding:34px 0"><img width="210px" height="210px" src="${agent.qrcode}"></div><div style="text-align:center">微信号: ${agent.wechat}</div>`,
        showConfirmButton: false,
        dangerouslyUseHTMLString: true,
      })
    },
    showDrawer(info) {
      this.$emit('showDrawer', info)
    },
    getPrice(item) {
      if (item.price) {
        return item.price
      }
      return 0
    },
    getPriceCurrency(item) {
      if (item.currency) {
        if (item.currency === 'RMB') {
          return {
            decimal: ',',
            thousands: ',',
            prefix: '￥ ',
            precision: 0,
            masked: false,
          }
        }
      }
      return {
        decimal: ',',
        thousands: ',',
        prefix: '$ ',
        precision: 0,
        masked: false,
      }
    },
  },
}
</script>

<style>
/*全局样式*/
.wechat-popup {
  width: 291px;
}
</style>

<style lang="less" scoped>
@import url('../../assets/less/var.less');

.fs14 {
  font-size: 14px;
}
.fs16 {
  font-size: 16px;
}
.fs24 {
  font-size: 24px;
}
.color-gray {
  color: rgba(0, 0, 0, 0.5);
}

.floating-agent {
  width: 291px;
  box-sizing: border-box;
  padding: 31px 14px 24px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
}
.price {
  margin-bottom: 22px;

  .price-total,
  .price-room {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    align-items: center;
  }
  .price-total {
    margin-bottom: 28px;
    .line-through input {
      text-decoration: line-through;
    }
  }

  .price-num {
    font-size: 16px;
    color: @theme-color;
    input {
      display: inline-block;
      width: 148px;
      outline: none;
      border: none;
      background: none;
      color: @theme-color;
      text-align: right;
      cursor: pointer;
      font-weight: bold;
      font-size: 24px;
      pointer-events: none;
    }
  }
  .price-total .price-num {
    font-weight: bold;
    font-size: 24px;
    small {
      font-size: 14px;
    }
  }
  .price-room.disabled {
    color: rgba(0, 0, 0, 0.5);
    .price-num {
      font-size: 16px;
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
.price-calc {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: space-between;

  input {
    display: inline-block;
    width: 120px;
    outline: none;
    border: none;
    background: none;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    text-align: right;
    pointer-events: none;
  }
}

@media (max-width: 767px) {
  .floating-agent {
    width: 100%;
    padding: 18px 14px;
    margin-top: 14px;
  }

  .price {
    margin-bottom: 0;

    .price-total {
      margin-bottom: 18px;
    }

    .price-num input {
      width: 150px;
      max-width: 48vw;
      font-size: 22px;
    }
  }
}
</style>
